import React, { Component } from 'react';
import moment from 'moment';
import momentz from 'moment-timezone';
import { withRouter } from 'react-router-dom';
import cookie from 'react-cookies';
import Snackbar from '@material-ui/core/Snackbar';
import styles from './OptionsBoardStyles';
import queryString from '../../utils/query-string';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import WatchListAdd from '../../components/Modals/WatchListAdd';
import HolderModal from '../../components/Modals/Holders Modal';
import DesktopView from './DesktopView';
import { connect } from 'react-redux';
import ActionTypes from '../../actions/types';
import MobileView from './MobileView';
import {
  arrivedViaQueryFunc,
  callRows,
  makeReStructuredRows,
  putRows,
  refreshDataAndExpirationsFunc,
} from '../../Shared';

let localSelectedDate;
class OptionsBoard extends Component {
  UNSAFE_componentWillMount() {
    window.onunload = function () {
      localStorage.setItem(
        'Date',
        momentz.tz(new Date(), 'America/New_York').format('YYYY-MM-DD')
      );
    };
    const returnVisitor = cookie.load('returnVisitor');
    let date;
    let datetoSend;

    const { accessLevel } = this.props.appState;
    const { selectedDate, strikeValue } = this.props.optionChainState;
    date =
      localStorage.getItem('Date') && accessLevel === 'fullaccess'
        ? localStorage.getItem('Date')
        : selectedDate;
    datetoSend =
      moment(date).isSame(selectedDate) && accessLevel === 'fullaccess'
        ? is_weekend(date)
        : date;
    if (date) {
      this.props.setOptionChainStateAction({
        selectedDate: datetoSend,
        modalDate: datetoSend,
      });
      localSelectedDate = datetoSend;
    }
    localStorage.setItem('StrikeValue', strikeValue);

    if (this.props.expiration) {
      this.props.setOptionChainStateAction({ isDateSelected: true });
    }
    if (returnVisitor) {
    } else {
      this.props.setOptionChainStateAction({ showModal: true }); // Show 'how to' only first time visitor comes to site
      cookie.save('returnVisitor', true); // Save status as return visitor so not shown modal next time
    }
  }

  componentWillUnmount() {
    localStorage.setItem('SYMBOL', this.props.optionChainState.localTicker);
    localStorage.setItem('TYPE', '');
    this.props.setOptionChainStateAction({
      selectedDate: momentz
        .tz(new Date(), 'America/New_York')
        .format('YYYY-MM-DD'),
    });
  }
  componentDidUpdate(prevPros) {
    const { onPlay, data } = this.props.appState;
    if (!prevPros.appState.onPlay && onPlay) {
      this.props.setOptionChainStateAction({ showModal: true });
    }
    if (prevPros.appState.onPlay && !onPlay) {
      this.props.setOptionChainStateAction({ showModal: false });
    }
    if (data && prevPros.appState.data !== data) {
      const checkboxes = data.map((row) => {
        return { value: false };
      });

      if (
        !this.props.optionChainState.check.length &&
        !this.props.optionChainState.watchListModalIndex.length
      ) {
        this.props.setOptionChainStateAction({ check: checkboxes });
      }
      if (
        !this.props.optionChainState.checkPut.length &&
        !this.props.optionChainState.watchListModalIndex.length
      ) {
        this.props.setOptionChainStateAction({ checkPut: checkboxes });
      }
    }
  }
  myAsyncFunction = async (symbol) => {
    await this.props.setAppStateAction({ ticker: symbol, tickerChanged: true });
    refreshDataAndExpirationsFunc(
      symbol,
      localSelectedDate || this.props.optionChainState.selectedDate,
      this.props.appState,
      this.props.setAppStateAction
    );
    window.scroll(0, 0);
  };

  componentDidMount() {
    this.props.loginCheck();
    if (window.innerWidth < 1650 && window.innerWidth > 1401) {
      this.props.setOptionChainStateAction({ zoom: '88%' });
    } else if (window.innerWidth <= 1400 && window.innerWidth > 1280) {
      this.props.setOptionChainStateAction({ zoom: '80%' });
    } else if (window.innerWidth <= 1280 && window.innerWidth > 1024) {
      this.props.setOptionChainStateAction({ zoom: '72%' });
    } else if (window.innerWidth <= 1024 && window.innerWidth > 900) {
      this.props.setOptionChainStateAction({ zoom: '62%' });
    }

    const ticker = this.props.match.params.ticker
      ? this.props.match.params.ticker.toUpperCase()
      : '';
    this.props.match.params.ticker && localStorage.setItem('SYMBOL', ticker);
    this.props.setAppStateAction({ ticker });
    const query = queryString.parse(this.props.location.search);

    arrivedViaQueryFunc(
      query,
      this.props.optionChainState.selectedDate,
      this.props.appState,
      this.props.setAppStateAction
    );

    this.props.setOptionChainStateAction({
      articles: [],
    });

    const symbol = localStorage.getItem('SYMBOL');
    if (symbol !== '') {
      this.props.setOptionChainStateAction({ localTicker: symbol });
      this.props.history.push('/optionschain/' + symbol);
      // this.props.setAppStateAction({ ticker: symbol, tickerChanged: true });
      this.myAsyncFunction(symbol);
    }
  }

  handleClose = () => {
    const { isCopied } = this.props.optionChainState;
    this.props.setOptionChainStateAction({ isCopied: !isCopied });
  };
  setShowModalHolder = () =>
    this.props.setOptionChainStateAction({ holderModal: false });

  handleClickSnak = (DuplicateEntries, WatchListData) => {
    const { data } = this.props.appState;
    // eslint-disable-next-line eqeqeq
    if (DuplicateEntries && DuplicateEntries != WatchListData) {
      this.props.setOptionChainStateAction({ alertType: 'warning' });
      this.props.setOptionChainStateAction({
        snakMessage: `${WatchListData} Added to Watchlist ${DuplicateEntries}  Duplicate Entries `,
      });
    } else {
      this.props.setOptionChainStateAction({ alertType: 'success' });
      this.props.setOptionChainStateAction({
        snakMessage: 'Added to Watchlist',
      });
    }
    this.props.setOptionChainStateAction({ watchListModalIndex: [] });
    const checkboxes =
      data &&
      data.map((row) => {
        return { value: false };
      });
    this.props.setOptionChainStateAction({ check: checkboxes });
    this.props.setOptionChainStateAction({ checkPut: checkboxes });

    this.props.setOptionChainStateAction({ watchListModal: false });

    this.props.setOptionChainStateAction({ favioute: false });
    this.props.setOptionChainStateAction({ snakOpen: true });
  };
  changeBidAskMid = async (event) => {
    this.props.setOptionChainStateAction({ bidAskMid: event.target.value });
    setTimeout(() => {
      const updatedRows = makeReStructuredRows(this.props);
      this.props.setOptionChainStateAction({
        noOMS: updatedRows.noOMS,
        callRows: updatedRows.callRows,
        putRows: updatedRows.putRows,
      });
    }, 500);
  };

  render() {
    const { quoteInfo, width, holderList, userData } = this.props.appState;

    const { latestPrice } = quoteInfo;
    const isMobile = width < 850;

    const {
      watchListModal,
      watchListModalIndex,
      isCopied,
      selectedDate,
      localTicker,
      nearValue,
      holderModal,
    } = this.props.optionChainState;

    this.props.optionChainState.nearValue =
      this.props.optionChainState.nearValue === undefined
        ? latestPrice
        : (this.props.optionChainState.nearValue = Number(
            this.props.optionChainState.nearValue
          ));

    let lengthCheck = false;
    if (Object.keys(holderList).length > 0) {
      if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
        lengthCheck = true;
      }
    }
    if (!isMobile)
      return (
        <DesktopView
          rows={
            this.props.optionChainState.showAdvancedBoard === 'Calls'
              ? callRows
              : putRows
          }
          changeBidAskMid={this.changeBidAskMid}
          nearValue={nearValue}
          handleClickSnak={this.handleClickSnak}
        />
      );
    return (
      <div style={styles.containerMobile}>
        <Snackbar
          open={isCopied}
          autoHideDuration={5000}
          onClose={this.handleClose}
          message="Copied Successfully!"
        ></Snackbar>
        {watchListModal && watchListModalIndex.length ? (
          <WatchListAdd
            latestPrice={latestPrice}
            handleClickSnak={this.handleClickSnak}
            date={selectedDate}
            symbol={localTicker}
            setShowModal={() =>
              this.props.setOptionChainStateAction({ watchListModal: false })
            }
            showModal={watchListModal}
            isMobile={isMobile}
            watchListModalIndex={watchListModalIndex}
            userData={userData}
          />
        ) : null}

        {holderModal && lengthCheck && (
          <HolderModal
            symbol={localTicker}
            showModal={holderModal}
            setShowModal={this.setShowModalHolder}
          />
        )}
        <MobileView rows={
            this.props.optionChainState.showAdvancedBoard === 'Calls'
              ? callRows
              : putRows
          }
          changeBidAskMid={this.changeBidAskMid} />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  appState: state.appReducer,
  optionChainState: state.optionChainReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
  setOptionChainStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_OPTION_CHAIN_STATE,
      payload: newState,
    }),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OptionsBoard)
);



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/index.js